import { render, staticRenderFns } from "./RegsitrationDetails.vue?vue&type=template&id=ac548c24&scoped=true&"
import script from "./RegsitrationDetails.vue?vue&type=script&lang=js&"
export * from "./RegsitrationDetails.vue?vue&type=script&lang=js&"
import style0 from "./RegsitrationDetails.vue?vue&type=style&index=0&id=ac548c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac548c24",
  null
  
)

export default component.exports